import { Paxes } from "./paxes";
import { Rates } from "./rates";

export class Room {
  paxes: Paxes[];
  rates: Rates[];
  name: string;
  net: string;
}
